export const formatAddressResults = data => {
    if (!data) return;

    const location = {};
    data.address_components.forEach(address => {
        switch (address.types[0]) {
        case 'country':
            location.country = address.long_name;
            break;
        case 'administrative_area_level_1':
            location.state = address.short_name;
            break;
        case 'administrative_area_level_2':
            location.city = address.long_name;
            break;
        case 'sublocality':
            location.street = address.short_name;
            break;
        case 'street_number':
            location.streetNumber = address.short_name;
            break;
        case 'route':
            location.route = address.short_name;
            break;
        case 'neighborhood':
        case 'political':
            location.neighborhood = address.long_name;
            break;
        case 'postal_code':
            location.postalCode = address.long_name;
            break;
        }
    });

    if (!location.formatted) {
        location.formatted = data.formatted_address;
    }

    if (!location.coordinates) {
        location.coordinates = data.geometry.location;
    }

    return location;
};



// WEBPACK FOOTER //
// ./src/scripts/shared/google.js